module.exports = __webpack_public_path__ + "static/media/moneyback-guarantee.41dfdaf4.png";